import React, { useMemo, useState } from "react";
import Post from "../Post/Post";
import { useDispatch, useSelector } from "react-redux";
import './styles.scss'; 
import { Backdrop, CircularProgress, Grid, Grow, Stack, styled, Typography, useMediaQuery } from "@mui/material";
import styles from './styles'; 
import LoadingIcon from "../Icons/LoadingIcon/LoadingIcon";
import { Box } from "@mui/system";
import ViewPost from "../ViewPost/ViewPost";
import { useEffect } from "react";
import getAverageColors from "../../utils/getAverageColors";
import useBeforeRender from "../../hooks/useBeforeRender";
import LavaLoader from "../Icons/LavaLoader/LavaLoader";
import LoadingIcon2 from "../Icons/LoadingIcon2.jsx/LoadingIcon2";
import { useParams } from "react-router-dom";
import { getPost } from "../../actions/posts";
import MediaPost from "../MediaPost.jsx/MediaPost";

const Posts = ({posts = [], isLoading, currentId, setCurrentId, onPostClick, disableDefaultPostClick}) => {

    const [selectedPost, setSelectedPost] = useState(null ); 
    const dirURL = '/posts';
    const {id} = useParams(); 
    const dispatch = useDispatch();
    const isMobile = useMediaQuery('(max-width: 768px)');


    useEffect(()=>{
        //for when a post is initially passed in the url, usually on reload or access from externally shared url
        if(id && !isMobile){ //should only be on desktop devices

            //get the actual post using dispatch
            dispatch(getPost(id, (error, res) =>{

                console.log('**********Posts res: ', res);

                if(error){
                    return console.warn('Posts.jsx error: ', error);
                }

                //set current post to returned post
                if(res){
                    setSelectedPost(res.data);
                }
                
            }));
            
        }

    }, [id]);
    
    if(!posts.length && !isLoading){

        return (
            <Box sx={{height: '200px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center'}}> 
                <Typography variant="h5">
                    No Posts yet, check back soon!
                </Typography>
            </Box>
        );

    }

    const handleOverlayClick = (event) => {

        

        let className = event.target.getAttribute('class') || ''; 
        if(className.includes('popup-overlay')){
            //remove post id from url
            const origin = window.location.origin; 
            window.history.pushState({},'',origin+dirURL); 

            //set selected post to null
            setSelectedPost(null); 
        }
    }


    const handlePostClick = (post) => {


        if(!disableDefaultPostClick){

            console.log('handle post click triggered');
            //this function on gets invoked on non-mobile devices

            //changing url without reload:

            const url = new URL(window.location); 

            //TODO: remove previous post id if present

            //update url
            window.history.pushState({},'',url+'/'+post._id); 

            setSelectedPost(post);

        }

        if(typeof onPostClick === 'function'){
            onPostClick(post);
        }

        
    }

    return (
        
        
        <Stack
            className="postsContainer"
            container
            alignItems="center"
            direction="column"
            spacing={3}
            sx={{marginTop: '0px', transition: '0.6s'}}
            elevation={0}
        >

            {posts.map((post, index) => {

                let postComponent = <MediaPost post={post} animated={index < 2 ? true: false} setCurrentId={setCurrentId} setSelectedPost={handlePostClick}/>

                if(post.postType === 'entityPost'){ //because already created posts don't have a postType and are all mediaPosts

                    postComponent = <Post post={post} animated={index < 2 ? true: false} setCurrentId={setCurrentId} setSelectedPost={handlePostClick}/>
                }

                

                return (
                    <Grid key={post._id} item variant="fullbleed" sx={styles.postContainer}> 
                        {postComponent}
                    </Grid>
                );
            })}

            

                
            {
                isLoading &&
                <LoadingIcon />
            }
                
                

            


            <Backdrop
                open={selectedPost !== null}
                sx={styles.popUpOverlay}
            >

                
                    
                    <Box
                        className='popup-overlay'
                        sx={styles.popUpBox}
                        onClick={handleOverlayClick} 
                    >
                        { selectedPost && 
                            <ViewPost post={selectedPost}  />
                        }
                        
                    </Box>
                        
                            
                    
                    
                 
                

            </Backdrop>
            

        </Stack>
        
        
    
    );
}

export default Posts;